import * as React from "react";
import { Typography, Button, Paper, FormControl, InputLabel, Select, MenuItem, Box } from "../mui";
import { GetAppRoundedIcon } from "../icons";

import TablePagination from "./TablePagination";
import "../../styles/components/dataTableCard.css";

export default function DataTableCard({
  title,
  children,
  showExport = true,
  actions,
  showEntriesControl = true,
  entriesOptions = [10, 20, 30],
  defaultEntries = 30,
  onEntriesChange,
  onExport,
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  totalEntries = 0,
  startEntry = 1,
  endEntry = 0,
  showFooter = true,
  className = ""
}) {
  const [entries, setEntries] = React.useState(defaultEntries);

  const handleEntriesChange = (event) => {
    const value = event.target.value;
    setEntries(value);
    if (onEntriesChange) {
      onEntriesChange(value);
    }
  };

  return (
    <Paper elevation={0} className={`content-box data-table-card ${className}`.trim()}>
      <div className="data-table-card-header">
        <Typography variant="subtitle1" className="data-table-title">
          {title}
        </Typography>
        <Box display="flex" alignItems="center" gap={1.5}>
          {actions}
          {showExport && (
            <Button 
              variant="contained" 
              startIcon={<GetAppRoundedIcon />}
              onClick={onExport}
            >
              Export
            </Button>
          )}
        </Box>
      </div>

      {showEntriesControl && (
        <div className="data-table-controls">
          <div className="data-table-control">
            <Typography component="span" variant="body2" className="data-table-control-label">
              Show
            </Typography>
            <FormControl size="small" className="data-table-select">
              <Select 
                value={entries}
                onChange={handleEntriesChange}
              >
                {entriesOptions.map((value) => (
                  <MenuItem key={value} value={value}>
                    {value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography component="span" variant="body2" className="data-table-control-label">
              entries
            </Typography>
          </div>
        </div>
      )}

      {children}

      {showFooter && (
        <Box className="data-table-footer">
          <Typography variant="caption" className="data-table-summary">
            Showing {startEntry} to {endEntry} of {totalEntries} entries
          </Typography>
          <TablePagination 
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </Box>
      )}
    </Paper>
  );
}
